import React from 'react';
import { cn } from '@/lib/utils';

// Fail-safe entrance: content is always visible (base opacity 1); a one-time
// CSS fade-up plays on mount. No `delay` stagger to avoid mid-animation flashes
// and to guarantee content can never get stuck hidden.
export default function Reveal({ children, className, delay, as: Tag = 'div' }) {
  return <Tag className={cn('bp-reveal', className)}>{children}</Tag>;
}
